import ErrorsInfo from "./error_info";
import ErrorFilterButton from "./error_filter_button";

const InfoBunners = () => {
    return (
        <div style={{ display: "flex", alignItems: "center", columnGap: '13px' }}>
            <ErrorsInfo />
            <ErrorFilterButton />
        </div>
    );
};

export default InfoBunners;